import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // desteklenmezse auto gibi davranır
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;